export const COMMON_DATE_FORMAT = 'YYYY-MM-DD';
export const EditorToolbarOptions = [
    'blockType',
    'inline',
    'textAlign',
    'fontSize',
    'list',
    'link',
    'history',
    'colorPicker',
];
export const DEFAULT_FILE_NAME = 'attachment.pdf';
export const IMPORT_FAQ_PAGE_URL = 'https://intercom-help.eu/debbie-eu/da/articles/596989-import-af-sager-via-excel-ark';
export const CREATE_CREDITOR_FAQ_PAGE_URL = 'https://intercom-help.eu/debbie-eu/da/articles/596981-oprettelse-af-kreditorer';
export const PHONE_QUEUE_PAGE_URL = 'https://intercom-help.eu/debbie-eu/da/articles/596970-prioritering-af-udgaende-opkald';
//# sourceMappingURL=constants.js.map